// IMPORTANT!! When changing this file make sure to make the same change in file %SRCROOT%\osfjs\mos\converter\src\xmlUtil.ts
namespace OSF {
  //constants to prevent DOS attack
  export enum XmlConstants {
    MaxXmlSize = 1048576,
    MaxElementDepth = 64,
  }

  /// <summary>
  /// Xpath 3 Provider
  /// </summary>
  /// <param name="xmldoc">xml string</param>
  /// <param name="xmlNamespaces">namespaces</param>
  /// <accessibility>private</accessibility>
  export class Xpath3Provider {
    _defaultNamespace: any;
    _evaluator: any;
    _namespaceMapping: any;
    _resolver: any;
    _xmldoc: any;
    constructor(xml, xmlNamespaces) {
      this._xmldoc = new DOMParser().parseFromString(xml, "text/xml");
      this._evaluator = new XPathEvaluator();
      this._namespaceMapping = {};
      this._defaultNamespace = null;
      var namespaces = xmlNamespaces.split(" ");
      var matches;
      for (var i = 0; i < namespaces.length; ++i) {
        matches = /xmlns="([^"]*)"/g.exec(namespaces[i]);
        if (matches) {
          this._defaultNamespace = matches[1];
          continue;
        }
        matches = /xmlns:([^=]*)="([^"]*)"/g.exec(namespaces[i]);
        if (matches) {
          this._namespaceMapping[matches[1]] = matches[2];
          continue;
        }
      }
      this._resolver = this;
    }
    lookupNamespaceURI(prefix) {
      var ns = this._namespaceMapping[prefix];
      return ns || this._defaultNamespace;
    }
    addNamespaceMapping(namespacePrefix, namespaceUri) {
      var ns = this._namespaceMapping[namespacePrefix];
      if (ns) {
        return false; // the namespace prefix is already defined
      } else {
        this._namespaceMapping[namespacePrefix] = namespaceUri;
        return true;
      }
    }
    getNamespaceMapping(): any {
      return this._namespaceMapping;
    }
    selectSingleNode(name, contextNode) {
      var xpath = (contextNode ? "./" : "/") + name;
      contextNode = contextNode || this.getDocumentElement();
      var result = this._evaluator.evaluate(
        xpath,
        contextNode,
        this._resolver,
        XPathResult.FIRST_ORDERED_NODE_TYPE,
        null,
      );
      if (result) {
        return result.singleNodeValue;
      } else {
        return null;
      }
    }
    selectNodes(name, contextNode) {
      var xpath = (contextNode ? "./" : "/") + name;
      contextNode = contextNode || this.getDocumentElement();
      var result = this._evaluator.evaluate(
        xpath,
        contextNode,
        this._resolver,
        XPathResult.ORDERED_NODE_ITERATOR_TYPE,
        null,
      );
      var nodes = [];
      if (result) {
        var node = result.iterateNext();
        while (node) {
          nodes.push(node);
          node = result.iterateNext();
        }
      }
      return nodes;
    }
    selectNodesByXPath(xpath, contextNode) {
      var result = this._evaluator.evaluate(
        xpath,
        contextNode,
        this._resolver,
        XPathResult.ORDERED_NODE_ITERATOR_TYPE,
        null,
      );
      var nodes = [];
      if (result) {
        var node = result.iterateNext();
        while (node) {
          nodes.push(node);
          node = result.iterateNext();
        }
      }
      return nodes;
    }
    getDocumentElement() {
      return this._xmldoc.documentElement;
    }
  }

  /// <summary>
  /// IE Xpath Provider
  /// </summary>
  /// <param name="xmldoc">xml string</param>
  /// <param name="xmlNamespaces">namespaces</param>
  /// <accessibility>private</accessibility>
  export class IEXpathProvider {
    _xmldoc: any;
    constructor(xml, xmlNamespaces) {
      var xmldoc = null;
      var msxmlVersions = ["MSXML2.DOMDocument.6.0"];
      for (var i = 0; i < msxmlVersions.length; i++) {
        try {
          xmldoc = new ActiveXObject(msxmlVersions[i]);
          xmldoc.setProperty("ResolveExternals", false);
          xmldoc.setProperty("ValidateOnParse", false);
          xmldoc.setProperty("ProhibitDTD", true);
          xmldoc.setProperty("MaxXMLSize", OSF.XmlConstants.MaxXmlSize);
          xmldoc.setProperty("MaxElementDepth", OSF.XmlConstants.MaxElementDepth);
          xmldoc.async = false;
          xmldoc.loadXML(xml);
          xmldoc.setProperty("SelectionLanguage", "XPath");
          xmldoc.setProperty("SelectionNamespaces", xmlNamespaces);
          break;
        } catch (ex) {
          OsfMsAjaxFactory.msAjaxDebug.trace("xml doc creating error:" + ex);
        }
      }
      this._xmldoc = xmldoc;
    }
    selectSingleNode(name, contextNode) {
      var xpath = (contextNode ? "./" : "/") + name;
      contextNode = contextNode || this.getDocumentElement();
      return contextNode.selectSingleNode(xpath);
    }
    addNamespaceMapping(namespacePrefix, namespaceUri) {
      var existingNamespaces = this._xmldoc.getProperty("SelectionNamespaces");
      var newNamespacePrefix = "xmlns:" + namespacePrefix + "=";
      var newNamespaceMappingString = "xmlns:" + namespacePrefix + '="' + namespaceUri + '"';
      if (existingNamespaces.indexOf(newNamespacePrefix) != -1) {
        return false; // the namespace prefix is already defined
      }
      existingNamespaces = existingNamespaces + " " + newNamespaceMappingString;
      this._xmldoc.setProperty("SelectionNamespaces", existingNamespaces);
      return true;
    }
    getNamespaceMapping(): any {
      return null;
    }
    selectNodes(name, contextNode) {
      var xpath = (contextNode ? "./" : "/") + name;
      contextNode = contextNode || this.getDocumentElement();
      return contextNode.selectNodes(xpath);
    }
    selectNodesByXPath(xpath, contextNode) {
      return contextNode.selectNodes(xpath);
    }
    getDocumentElement() {
      return this._xmldoc.documentElement;
    }
    getActiveXObject() {
      return this._xmldoc;
    }
  }

  /// <summary>
  /// DomParser Provider
  /// </summary>
  /// <param name="xmldoc">xml string</param>
  /// <param name="xmlNamespaces">namespaces</param>
  /// <accessibility>private</accessibility>
  export class DomParserProvider {
    _defaultNamespace: any;
    _namespaceMapping: any;
    _xmldoc: any;
    constructor(xml, xmlNamespaces) {
      try {
        this._xmldoc = new DOMParser().parseFromString(xml, "text/xml");
      } catch (ex) {
        Sys.Debug.trace("xml doc creating error:" + ex);
      }
      // handle namespace
      this._namespaceMapping = {};
      this._defaultNamespace = null;
      var namespaces = xmlNamespaces.split(" ");
      var matches;
      for (var i = 0; i < namespaces.length; ++i) {
        matches = /xmlns="([^"]*)"/g.exec(namespaces[i]);
        if (matches) {
          this._defaultNamespace = matches[1];
          continue;
        }
        matches = /xmlns:([^=]*)="([^"]*)"/g.exec(namespaces[i]);
        if (matches) {
          this._namespaceMapping[matches[1]] = matches[2];
          continue;
        }
      }
    }
    addNamespaceMapping(namespacePrefix, namespaceUri) {
      var ns = this._namespaceMapping[namespacePrefix];
      if (ns) {
        return false; // The namespace prefix is already defined
      } else {
        this._namespaceMapping[namespacePrefix] = namespaceUri;
        return true;
      }
    }
    getNamespaceMapping(): any {
      return this._namespaceMapping;
    }
    selectSingleNode(name, contextNode) {
      var selectedNode = contextNode || this._xmldoc;
      var nodes = this._selectNodes(name, selectedNode);
      if (nodes.length === 0) return null;
      return nodes[0];
    }
    selectNodes(name, contextNode) {
      var selectedNode = contextNode || this._xmldoc;
      return this._selectNodes(name, selectedNode);
    }
    selectNodesByXPath(xpath, contextNode) {
      // Todo(OfficeVSO:81193): Try to support selectNodesByXPath in DomParserProvider.
      return null;
    }
    _selectNodes(name, contextNode) {
      var nodes = [];
      if (!name) return nodes;
      var nameInfo = name.split(":");
      var ns, nodeName;
      if (nameInfo.length === 1) {
        ns = null;
        nodeName = nameInfo[0];
      } else if (nameInfo.length === 2) {
        ns = this._namespaceMapping[nameInfo[0]];
        nodeName = nameInfo[1];
      } else {
        throw OsfMsAjaxFactory.msAjaxError.argument("name");
      }
      if (!contextNode.hasChildNodes) return nodes;
      var childs = contextNode.childNodes;
      for (var i = 0; i < childs.length; i++) {
        if (nodeName === this._removeNodePrefix(childs[i].nodeName) && ns === childs[i].namespaceURI) {
          nodes.push(childs[i]);
        }
      }
      return nodes;
    }
    _removeNodePrefix(nodeName) {
      var nodeInfo = nodeName.split(":");
      if (nodeInfo.length === 1) {
        return nodeName;
      } else {
        return nodeInfo[1];
      }
    }
    getDocumentElement() {
      return this._xmldoc.documentElement;
    }
  }

  /// <summary>
  /// XmlProcessor, cross browser XML parsing.
  /// </summary>
  /// <param name="xml">xml string</param>
  /// <param name="xmlNamespaces">xml Namespaces string</param>
  /// <accessibility>public</accessibility>
  export class XmlProcessor {
    _provider: any;
    constructor(xml, xmlNamespaces) {
      var e = Function._validateParams(arguments, [
        { name: "xml", type: String, mayBeNull: false },
        { name: "xmlNamespaces", type: String, mayBeNull: false },
      ]);
      if (e) throw e;
      if (document.implementation && document.implementation.hasFeature("XPath", "3.0")) {
        this._provider = new OSF.Xpath3Provider(xml, xmlNamespaces);
      } else {
        this._provider = new OSF.IEXpathProvider(xml, xmlNamespaces);
        if (!this._provider.getActiveXObject()) {
          // if we can't use activeXObject, fallback to DomParser
          this._provider = new OSF.DomParserProvider(xml, xmlNamespaces);
        }
      }
    }
    addNamespaceMapping(namespacePrefix, namespaceUri) {
      var e = Function._validateParams(arguments, [
        { name: "namespacePrefix", type: String, mayBeNull: false },
        { name: "namespaceUri", type: String, mayBeNull: false },
      ]);
      if (e) throw e;
      return this._provider.addNamespaceMapping(namespacePrefix, namespaceUri);
    }

    /// <summary>
    /// Get the namespace mapping
    /// </summary>
    getNamespaceMapping(): any {
      return this._provider?.getNamespaceMapping();
    }

    /// <summary>
    /// select a single node
    /// </summary>
    /// <accessibility>public</accessibility>
    /// <param name="name">XML node name</param>
    /// <returns>XML DOM Node object.</returns>
    selectSingleNode(name, contextNode) {
      var e = Function._validateParams(arguments, [
        { name: "name", type: String, mayBeNull: false },
        { name: "contextNode", mayBeNull: true, optional: true },
      ]);
      if (e) throw e;
      return this._provider.selectSingleNode(name, contextNode);
    }

    /// <summary>
    /// select all child nodes that match node name
    /// </summary>
    /// <accessibility>public</accessibility>
    /// <param name="name">XML node name</param>
    /// <returns>array of XML DOM Node objects.</returns>
    selectNodes(name, contextNode) {
      var e = Function._validateParams(arguments, [
        { name: "name", type: String, mayBeNull: false },
        { name: "contextNode", mayBeNull: true, optional: true },
      ]);
      if (e) throw e;
      return this._provider.selectNodes(name, contextNode);
    }

    /// <summary>
    /// select nodes that match the xpath query
    /// </summary>
    /// <accessibility>public</accessibility>
    /// <param name="xpath">xpath string</param>
    /// <returns>array of XML DOM Node objects.</returns>
    selectNodesByXPath(xpath, contextNode) {
      var e = Function._validateParams(arguments, [
        { name: "xpath", type: String, mayBeNull: false },
        { name: "contextNode", mayBeNull: true, optional: true },
      ]);
      if (e) throw e;
      contextNode = contextNode || this._provider.getDocumentElement();
      return this._provider.selectNodesByXPath(xpath, contextNode);
    }

    /// <summary>
    /// get root document element
    /// </summary>
    /// <accessibility>public</accessibility>
    /// <param name="node">DOM root document element</param>
    /// <returns>value of the node as string</returns>
    getDocumentElement() {
      return this._provider.getDocumentElement();
    }

    /// <summary>
    /// get node value
    /// </summary>
    /// <accessibility>public</accessibility>
    /// <param name="node">DOM element object</param>
    /// <returns>value of the node as string</returns>
    getNodeValue(node) {
      var e = Function._validateParams(arguments, [{ name: "node", type: Object, mayBeNull: false }]);
      if (e) throw e;
      var nodeValue;
      if (node.text) {
        //IE
        nodeValue = node.text;
      } else {
        //others
        nodeValue = node.textContent;
      }
      return nodeValue;
    }

    /// <summary>
    /// get node text
    /// </summary>
    /// <accessibility>public</accessibility>
    /// <param name="node">DOM element object</param>
    /// <returns>text of the node as string</returns>
    getNodeText(node) {
      var e = Function._validateParams(arguments, [{ name: "node", type: Object, mayBeNull: false }]);
      if (e) throw e;
      if (this.getNodeType(node) == 9) {
        //Handle special case for document node.
        //For document node on Chrome and Edge, the text and textContent of the node are both null.
        //Return the text of the document element here.
        return this.getNodeText(this.getDocumentElement());
      }
      var nodeText;
      if (node.text) {
        //IE
        nodeText = node.text;
      } else {
        //others
        nodeText = node.textContent;
      }
      return nodeText;
    }

    /// <summary>
    /// set node text
    /// </summary>
    /// <accessibility>public</accessibility>
    /// <param name="node">DOM element object</param>
    /// <param name="text">text be set to the node</param>
    /// <returns>True if text is set succesfully</returns>
    setNodeText(node, text) {
      var e = Function._validateParams(arguments, [
        { name: "node", type: Object, mayBeNull: false },
        { name: "text", type: String, mayBeNull: false },
      ]);
      if (e) throw e;
      if (this.getNodeType(node) == 9) {
        //Handle special case for document node.
        //For document node on Chrome and Edge, the text and textContent of the node are both null.
        //As the text for document node cannot be set, return false here.
        return false;
      }
      try {
        if (node.text) {
          //IE
          node.text = text;
        } else {
          //others
          node.textContent = text;
        }
      } catch (ex) {
        return false;
      }
      return true;
    }

    /// <summary>
    /// get node xml
    /// </summary>
    /// <accessibility>public</accessibility>
    /// <param name="node">DOM element object</param>
    /// <returns>xml of the node as string</returns>
    getNodeXml(node) {
      var e = Function._validateParams(arguments, [{ name: "node", type: Object, mayBeNull: false }]);
      if (e) throw e;
      var nodeXml;
      if (node.xml) {
        //IE
        nodeXml = node.xml;
      } else {
        //Others
        nodeXml = new XMLSerializer().serializeToString(node);
        if (this.getNodeType(node) == 2) {
          // Handle special case for attribute node.
          nodeXml = this.getNodeBaseName(node) + '="' + nodeXml + '"';
        }
      }
      return nodeXml;
    }

    /// <summary>
    /// set node xml
    /// </summary>
    /// <accessibility>public</accessibility>
    /// <param name="node">DOM element object</param>
    /// <param name="xml">xml be set to the node</param>
    /// <returns>new node after the xml set</returns>
    setNodeXml(node, xml) {
      var e = Function._validateParams(arguments, [
        { name: "node", type: Object, mayBeNull: false },
        { name: "xml", type: String, mayBeNull: false },
      ]);
      if (e) throw e;
      var processor = new OSF.XmlProcessor(xml, "");
      if (!processor.isValidXml()) {
        return null;
      }
      var newNode = processor.getDocumentElement();
      try {
        node.parentNode.replaceChild(newNode, node);
      } catch (ex) {
        return null;
      }
      return newNode;
    }

    /// <summary>
    /// get node namespaceURI
    /// </summary>
    /// <accessibility>public</accessibility>
    /// <param name="node">DOM element object</param>
    /// <returns>namespaceURI of the node as string</returns>
    getNodeNamespaceURI(node) {
      var e = Function._validateParams(arguments, [{ name: "node", type: Object, mayBeNull: false }]);
      if (e) throw e;
      return node.namespaceURI;
    }

    /// <summary>
    /// get node prefix
    /// </summary>
    /// <accessibility>public</accessibility>
    /// <param name="node">DOM element object</param>
    /// <returns>prefix of the node as string</returns>
    getNodePrefix(node) {
      var e = Function._validateParams(arguments, [{ name: "node", type: Object, mayBeNull: false }]);
      if (e) throw e;
      return node.prefix;
    }

    /// <summary>
    /// get node baseName
    /// </summary>
    /// <accessibility>public</accessibility>
    /// <param name="node">DOM element object</param>
    /// <returns>baseName of the node as string</returns>
    getNodeBaseName(node) {
      var e = Function._validateParams(arguments, [{ name: "node", type: Object, mayBeNull: false }]);
      if (e) throw e;
      var nodeBaseName;
      // localName: http://www.w3schools.com/xml/prop_node_localname.asp
      // nodename: http://www.w3schools.com/xml/prop_node_nodename.asp
      // baseName: https://msdn.microsoft.com/en-us/library/ms767570(v=vs.85).aspx
      if (node.nodeType && (node.nodeType == 1 || node.nodeType == 2)) {
        // For element node and attribute node, use the baseName (IE) or localName (Others)
        if (node.baseName) {
          //IE
          nodeBaseName = node.baseName;
        } else {
          //others
          nodeBaseName = node.localName;
        }
      } else {
        // For other nodetype, use nodeName as the basename
        nodeBaseName = node.nodeName;
      }
      return nodeBaseName;
    }

    /// <summary>
    /// get node type
    /// </summary>
    /// <accessibility>public</accessibility>
    /// <param name="node">DOM element object</param>
    /// <returns>type of the node as int</returns>
    getNodeType(node) {
      var e = Function._validateParams(arguments, [{ name: "node", type: Object, mayBeNull: false }]);
      if (e) throw e;
      return node.nodeType;
    }

    /// <summary>
    /// append child node with child xml
    /// </summary>
    /// <accessibility>public</accessibility>
    /// <param name="node">DOM element object</param>
    /// <param name="childXml">child xml be appended to the node</param>
    /// <returns>new child node after the xml appended</returns>
    appendChild(node, childXml) {
      var e = Function._validateParams(arguments, [
        { name: "node", type: Object, mayBeNull: false },
        { name: "childXml", type: String, mayBeNull: false },
      ]);
      if (e) throw e;
      var processor = new OSF.XmlProcessor(childXml, "");
      if (!processor.isValidXml()) {
        return null;
      }
      var childNode = processor.getDocumentElement();
      node.appendChild(childNode);
      return childNode;
    }

    /// <summary>
    /// get node value
    /// </summary>
    /// <accessibility>private</accessibility>
    /// <param name="attribute">DOM attribute object</param>
    /// <returns>value of the node as string</returns>
    _getAttributeLocalName(attribute) {
      var localName;
      if (attribute.localName) {
        //non IE
        localName = attribute.localName;
      } else {
        //IE
        localName = attribute.baseName;
      }
      return localName;
    }

    /// <summary>
    /// read attributes to fill the object
    /// </summary>
    /// <accessibility>public</accessibility>
    /// <param name="node">DOM element object</param>
    /// <param name="attributesToRead">attributes to read</param>
    /// <param name="objectToFill">object to fill with attribute values</param>
    readAttributes(node, attributesToRead, objectToFill) {
      var e = Function._validateParams(arguments, [
        { name: "node", type: Object, mayBeNull: false },
        { name: "attributesToRead", type: Object, mayBeNull: false },
        { name: "objectToFill", type: Object, mayBeNull: false },
      ]);
      if (e) throw e;
      var attribute;
      var localName;
      for (var i = 0; i < node.attributes.length; i++) {
        attribute = node.attributes[i];
        localName = this._getAttributeLocalName(attribute);
        for (var p in attributesToRead) {
          if (localName === p) {
            objectToFill[attributesToRead[p]] = attribute.value;
          }
        }
      }
    }

    /// <summary>
    /// Identify whether the xml string passed to the processor is valid
    /// </summary>
    isValidXml() {
      var documentElement = this.getDocumentElement();
      if (documentElement == null) {
        return false;
      } else if (this._provider._xmldoc.getElementsByTagName("parsererror").length > 0) {
        var parser = new DOMParser();
        var errorParse = parser.parseFromString("<", "text/xml");
        var parseErrorNS = errorParse.getElementsByTagName("parsererror")[0].namespaceURI;
        return this._provider._xmldoc.getElementsByTagNameNS(parseErrorNS, "parsererror").length <= 0;
      }
      return true;
    }
  }
}
